import React from "react";
import { PropTypes } from "prop-types";
import "./_hero-max.scss";
export const HeroMax = ({ children, img, alt, css, decorative = false}) => {
  return (
    <div className={`hero-max ${css}`}>
      <img className="hero-max__bg" src={img} alt={alt} aria-hidden={decorative ? "true" : "false"} />
      <div className="hero-max__container">
        <div className="hero-max__box">
          {children}
        </div>
      </div>
    </div>
  );
};

HeroMax.propTypes = {
  img: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  decorative: PropTypes.bool
};
